import { all } from "redux-saga/effects";

import { watchLoadKeyholders } from "./load";
import * as actions from "./actions/";

export function* rootSaga() {
  yield all([watchLoadKeyholders(), actions.rootSaga()]);
}
